const eventSortCoupon = (name, type) => {
  if (typeof window !== 'undefined' && name) {
    (window as any)?.dataLayer?.push({
      event: `generalEvent`,
      eventName: `${type}_servis_urutkan_button`,
      eventCategory: `${type} servis page`,
      eventAction: `click on ${name?.toLowerCase()}`,
    });
  }
};
export default eventSortCoupon;
